import { nanoid } from "nanoid";
import React from "react";
import interactiveCoursesImg from "../../../../../../../assets/img/interactivecourses.png";
import assessmentsImg from "../../../../../../../assets/img/assessments.png";
import realworldcasesImg from "../../../../../../../assets/img/realworldcases.png";
import quizzesImg from "../../../../../../../assets/img/quizzes.png";
import minigamesImg from "../../../../../../../assets/img/minigames.png";

const TabContent = (props) => {
  const getImage = (image) => {
    switch (image) {
      case "interactivecourses":
        return interactiveCoursesImg;
      case "funassesments":
        return assessmentsImg;
      case "realworldcases":
        return realworldcasesImg;
      case "quizzes":
        return quizzesImg;
      case "minigames":
        return minigamesImg;
    }
  };

  console.log(getImage(props.image));
  return (
    <div className="flex flex-col md:flex-row items-center mb-12">
      <div className="w-1/2 flex flex-row justify-center items-center">
        <img src={getImage(props.image)} alt={props.title} />
      </div>
      <div className="w-full md:w-1/2">
        <div className="text-left">
          <div className="mt-8 md:mt-0">
            <h2 className="text-lg font-bold">
              <i className="fi flaticon-fast-forward text-sm"></i> {props.title}
            </h2>
          </div>
          <p className="text-sm text-gray-700 my-6">{props.featureDesc}</p>
          <ul className="features-list list-with-green-check">
            {props.featuresList.map((feature) => (
              <li key={nanoid()}>
                <i className="fi flaticon-tick"></i> {feature}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TabContent;
